import {AfterViewInit, Component, OnDestroy, OnInit, Input, Output, EventEmitter} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { EventManager } from "src/app/core";
import { Constant } from "src/app/core/constant";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: 'documents',
  templateUrl: "./documents.html",
  styleUrls: [
  ]
})

export class DocumentsComponent implements OnInit, AfterViewInit, OnDestroy  {
    @Input('profileId') profileId: any;
    @Input('isOldImage ') isOldImage : boolean = false;;
    @Input('documents') documents: any;
    @Input('viewCode') viewCode: any;
    photo: any;
    Constant = Constant;
    constructor(
        private translate: TranslateService,
        private eventManagerService: EventManager,
    ) {

    }
    ngOnInit() {
        this.photo = {};
    }
    ngAfterViewInit() {
        
    }
    ngOnDestroy() {
    }
    showPhoto(document) {
        // this.dialog.showModal(ViewImageComponent, 'view-image-modal', {photo: document});
    }
}
